"use client";

import Checkbox from '@/uicomponents/Checkbox';
import TypoGraphy, { Variants } from '@/typography';
import { useContext, useEffect, useRef } from 'react';
import './index.scss';
import { useParams } from 'next/navigation';
import { RouteStrings } from '@/utils/routestrings';
import { AppContext } from '@/contexts/appcontext';
import { getSlugAndRouteName } from '@/utils/Functions';
import MobileFilter from '@/uicomponents/MobileFilter';
import useViewType from '@/utils/Hooks/useViewType';
const Sidebar = ({
  data,
  subIndustriesData
}: any) => {
  const isMobile = useViewType();
  const industriesWithData = data?.data;
  const params = useParams();
  const {
    slug,
    isIndustry,
    isSubIndustry
  } = getSlugAndRouteName(params?.route?.toString() ?? '');
  const subIndustryNames = subIndustriesData?.data?.map((card: any) => card.attributes.subIndustry);
  const currentSubIndustry = subIndustryNames?.find((item: string) => item.toLowerCase() === slug);
  const currentIndustry = industriesWithData.find((item: any) => {
    return item?.attributes?.industryName.toLowerCase() === slug;
  });
  const currentSubIndustryRef = useRef<HTMLDivElement>(null);
  const industryRef = useRef<HTMLDivElement>(null);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile || !isIndustry && !isSubIndustry || !ref?.current) return;
    if (isSubIndustry && currentSubIndustryRef?.current) {
      ref.current.scrollTop = currentSubIndustryRef?.current?.offsetTop;
      return;
    }
    if (industryRef?.current) ref.current.scrollTop = industryRef?.current?.offsetTop;
  }, []);
  const {
    isAll,
    setIsAll,
    isAdvanced,
    setisAdvanced,
    isIntermediate,
    setIntermediate,
    isBeginner,
    setIsBeginner
  } = useContext<any>(AppContext);
  const getSubIndustryFont = (subIndustry: string): Variants => {
    if (currentSubIndustry?.replaceAll('-', " ")?.toLowerCase() === subIndustry?.replaceAll('-', " ")?.toLowerCase()) return 'Desktop/Body 2/M | 14 |120';
    return 'Desktop/Body 2/R | 14 |120';
  };
  return <>
            <div className='sidebar_sticky_wrapper' suppressHydrationWarning>
                <div className='sidebar_wrapper' ref={ref}>
                    <div className="category_wrapper">
                        <div className="category_heading">
                            <TypoGraphy text='Industry' variant='Desktop/Heading 1/S | 20 |120' data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
                        </div>
                        <div className="category_content">
                            {industriesWithData?.map((item: any, index: number) => {
              const filteredSubIndustries = subIndustriesData?.data?.filter((subIndustry: any) => subIndustry?.attributes?.industries?.data[0]?.id === item.id);
              return <div className="category_content_wrapper" key={`sidebar_content_index_number_${index}`} ref={!isSubIndustry && currentIndustry?.attributes?.industryName === item?.attributes?.industryName ? industryRef : null}>
                                        <TypoGraphy href={RouteStrings.DYNAMICROUTE(item?.attributes?.industryName, 'INDUSTRY', item?.id)} text={item.attributes.industryName} variant='Mobile/Body 1/M | 16 | 160' tagName='a' title={`Free ${item?.attributes?.industryName} Courses`} isArticle />
                                        {filteredSubIndustries?.length > 0 && <div className="content_list">
                                            {filteredSubIndustries?.map((element: any, subindex: number) => <div ref={element?.attributes?.subIndustry === currentSubIndustry ? currentSubIndustryRef : null} key={`sub_index_${subindex + index}`}>
                                                <TypoGraphy text={element?.attributes?.subIndustry} tagName='a' isArticle title={`Free ${element?.attributes?.subIndustry} Courses`} href={RouteStrings.DYNAMICROUTE(element?.attributes?.subIndustry.replaceAll(' ', '-'), 'SUBINDUSTRY', element?.id)} variant={getSubIndustryFont(element?.attributes?.subIndustry)} key={`item_${index}`} />
                                                </div>)}
                                        </div>}
                                        {index !== industriesWithData?.length - 1 && <svg xmlns="http://www.w3.org/2000/svg" width="235" height="2" viewBox="0 0 235 2" fill="none">
                                            <path d="M1 1H234" stroke="#030A21" strokeOpacity="0.1" strokeLinecap="round" />
                                        </svg>}
                                        
                                    </div>;
            })}
                        </div>
                    </div>
                    <div className="category_wrapper" style={{
          paddingBottom: '50px'
        }}>
                        <div className="category_heading">
                            <TypoGraphy text='Expertise' variant='Desktop/Heading 1/S | 20 |120' data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
                        </div>
                        <div className="category_content" style={{
            paddingBottom: "120px"
          }}>
                            <Checkbox text={'Beginner'} isActive={isBeginner} setIsActive={setIsBeginner} textVariant='Desktop/Body 1/R | 16 |160' data-sentry-element="Checkbox" data-sentry-source-file="index.tsx" />
                            <Checkbox text={'Intermediate'} isActive={isIntermediate} setIsActive={setIntermediate} textVariant='Desktop/Body 1/R | 16 |160' data-sentry-element="Checkbox" data-sentry-source-file="index.tsx" />
                            <Checkbox text={'Advanced'} isActive={isAdvanced} setIsActive={setisAdvanced} textVariant='Desktop/Body 1/R | 16 |160' data-sentry-element="Checkbox" data-sentry-source-file="index.tsx" />
                            <Checkbox text={'All'} isActive={isAll.checked} setIsActive={() => {
              setIsAll({
                checked: !isAll.checked,
                state: true
              });
            }} textVariant='Desktop/Body 1/R | 16 |160' data-sentry-element="Checkbox" data-sentry-source-file="index.tsx" />
                        </div>
                    </div>
                </div>
            </div>
            <MobileFilter data={{
      data: industriesWithData
    }} currentSubIndustry={currentSubIndustry} data-sentry-element="MobileFilter" data-sentry-source-file="index.tsx" />
        </>;
};
export default Sidebar;